(function () {
    "use strict";

    // Chrome on Android does not reliably open the native time/date picker when the
    // picker indicator is hidden via CSS (see btddispo.css). On touch devices we open
    // it explicitly with showPicker(). Delegated on document so inputs rendered later
    // (e.g. by the React roster) are covered too.
    const PICKER_TYPES = new Set(["time", "date", "datetime-local", "month", "week"]);
    const coarsePointer = window.matchMedia("(pointer: coarse)");

    document.addEventListener("click", function (e) {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!PICKER_TYPES.has(input.type)) return;
        if (input.disabled || input.readOnly) return;
        if (typeof input.showPicker !== "function") return;
        if (e.pointerType ? e.pointerType === "mouse" : !coarsePointer.matches) return;

        try {
            input.showPicker();
            // prevent the browser's own default picker so it isn't opened twice
            e.preventDefault();
        } catch (err) {
            // showPicker throws a DOMException e.g. in cross-origin iframes (SecurityError)
            // or without user activation (NotAllowedError). Then we skip preventDefault so
            // the browser's default behaviour takes over. Anything else is a real bug.
            if (!(err instanceof DOMException)) throw err;
        }
    });
})();
